import NetworkLogic from "../Shared/NetworkLogic";
import AudioManager from "../Shared/AudioManager";
import UIManager from "../Shared/UIManager";
import Player from "../Models/Player";
import { Global } from "../Shared/Global";
import RemoteSprite from "../Common/RemoteSprite";
import HallUI from "./HallUI";
import EnterSoundManager from "../Shared/EnterSoundManager";
import Utils from "../Shared/Utils";
const i18n = require('LanguageData');


const { ccclass, property } = cc._decorator;

@ccclass
export default class VipLayer extends cc.Component {
    @property(cc.Node)
    iconHead: cc.Node = null;
    @property(cc.Label)
    washCodeProportion: cc.Label = null;
    @property(RemoteSprite)
    rspHead: RemoteSprite = null;
    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    item0: cc.Node = null;
    @property(cc.Node)
    item1: cc.Node = null;
    @property(cc.Label)
    labjjLingQu: cc.Label = null;
    @property(cc.Label)
    labWeekLingQu: cc.Label = null;
    @property(cc.Label)
    labMonLingQu: cc.Label = null;

    @property(cc.Label)
    labVipLevel: cc.Label = null;
    @property(cc.Label)
    labCurMoney: cc.Label = null;
    @property(cc.Label)

    labjjMoney: cc.Label = null;
    @property(cc.Label)
    labWeekMoney: cc.Label = null;
    @property(cc.Label)
    labMonMoney: cc.Label = null;

    @property(cc.Button)
    btnjj: cc.Button = null;
    @property(cc.Button)
    btnWeek: cc.Button = null;
    @property(cc.Button)
    btnMon: cc.Button = null;

    @property(cc.Layout)
    itemLayout: cc.Layout = null;

    data = null;
    userVipLevel: number = null;
    userVipSettings = null;
    tempLevel: number = null;
    private tempI: number = null;
    mePos = null;
    onLoad() {
        console.log("vipLayer启动成功")
    }

    /**
     * vipId: 1
     currentExp: 0
     upgradeGiftMoney: 0
     cycleGiftMoney: 0
     cycleStatus: ""
     monthStaus: ""
     monthGiftMoney: ""
     washCodeProportion: 0
     userVipSettings: Array(10)
     0:
     id: 1
     userVip: 1
     totalValidBetNumber: 0
     advanceGiftMoney: 0
     l: 0
     monthGiftMoney: 0
     specialChannel: 0
     exclusiveService: 0
     chukDmlMultiple: 1
     vipImageUrl: "http://api.fanyirong.com:8080/group1/zonghe/dcb25c5be2aeaa8a5032dc09eb3be6f7.jpg"
     status: 0
     receiveStatus: 1
     weekStatus: 1
     monthStatus: 1
     washCodeProportion: 89
     __proto__: Object
     1:
     id: 2
     userVip: 2
     totalValidBetNumber: 1
     advanceGiftMoney: 38
     weekGiftMoney: 18
     monthGiftMoney: 38
     specialChannel: 0
     exclusiveService: 0
     chukDmlMultiple: 1
     vipImageUrl: "http://api.fanyirong.com:8080/group1/zonghe/dcb25c5be2aeaa8a5032dc09eb3be6f7.jpg"
     status: 0
     receiveStatus: 2
     weekStatus: 2
     monthStatus: 2
     washCodeProportion: 100
     __proto__: Object
     2:
     id: 3
     userVip: 3
     totalValidBetNumber: 10
     advanceGiftMoney: 68
     weekGiftMoney: 28
     monthGiftMoney: 68
     specialChannel: 0
     exclusiveService: 0
     chukDmlMultiple: 1
     vipImageUrl: "http://api.fanyirong.com:8080/group1/zonghe/8d0f04cd103a792439f703f52883f087.png"
     status: 0
     receiveStatus: 2
     weekStatus: 2
     monthStatus: 2
     washCodeProportion: 84
     */
    start() {
        EnterSoundManager.playSound("enter_vip")
        Player.getPy("head") && (this.rspHead.url = Player.getPy("head"));
        this.node.getChildByName("bg").getComponent(cc.Sprite).setState(0);
        UIManager.showLoadingUI();
        NetworkLogic.vipShow(function (data) {
            UIManager.hideLoadingUI();
            console.log("======vip data:", data)
            this.data = data;
            this.labCurMoney.string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) +  data.currentExp;
            let vipId = data.vipId < 1 ? 1 : data.vipId;
            this.userVipSettings = data.userVipSettings;

            function compare(p) { //这是比较函数
                return function (m, n) {
                    var a = m[p];
                    var b = n[p];
                    return a - b; //升序
                }
            }
            this.userVipSettings.sort(compare("userVip"));

            for (let i = 0; i < this.userVipSettings.length; i++) {
                if (vipId === this.userVipSettings[i].id) {
                    this.userVipLevel = this.userVipSettings[i].userVip;
                    this.labVipLevel.string = "VIP" + this.userVipLevel;
                    this.tempI = i;

                }
                let tempitem = i % 2 === 0 ? this.item0 : this.item1;
                let item = cc.instantiate(tempitem);
                item.parent = this.content;
                item.active = true;
                let iconHeight = cc.find("icon/vip/spVip1", item);
                let labVip = cc.find("icon/vip/labVip", item);
                let labLimitMoney = cc.find("icon/bg/labLimitMoney", item);
                let itemData = this.userVipSettings[i];
                iconHeight.active = (itemData.userVip <= this.userVipLevel);
                labVip.getComponent(cc.Label).string = "VIP" + itemData.userVip;
                labLimitMoney.getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + (itemData.totalValidBetNumber * 10000).toString();
                item.getComponent(cc.Toggle).checkEvents[0].customEventData = i;
                if (itemData.userVip === this.userVipLevel) {
                    this.washCodeProportion.string = itemData.washCodeProportion + "%";
                    item.getComponent(cc.Toggle).check();
                    item.getChildByName("me").active = true;
                }
                if (i === this.userVipSettings.length - 1) {//隐藏最后一根线
                    item.getChildByName("line").active = false;
                }
            }
            this.itemLayout.updateLayout();
            let maxScrollOffset = this.scrollView.getMaxScrollOffset();
            this.mePos = maxScrollOffset.x * this.tempI / this.userVipSettings.length;
            this.scrollView.scrollToOffset(cc.v2(this.mePos, 0), 0.1);
        }.bind(this), function () {
            console.log("vip获取失败")
        })
    }

    onBtnClick(event, param) {
        AudioManager.playSound("button");
        if (param === "back") {
            AudioManager.playSound("close")
            this.node.destroy();
        }
        else if (param === "receive") {
            Utils.disable_btn_sec(event,5);
            let data = {
                "giftMoneyType": 1,
                "vipId": this.tempLevel
            };
            NetworkLogic.vipReceivReword(data, function () {
                this._receiveReword(1, data);

            }.bind(this), () => {
                console.log("===返回失败")
            })
        }
        else if (param === "week") {
            Utils.disable_btn_sec(event,5);
            let data = {
                "giftMoneyType": 2,
                "vipId": this.tempLevel
            }
            NetworkLogic.vipReceivReword(data, function () {
                this._receiveReword(2);
            }.bind(this), () => {
                console.log("===返回失败")
            })
        } else if (param === "month") {
            Utils.disable_btn_sec(event,5);
            let data = {
                "giftMoneyType": 3,
                "vipId": this.tempLevel
            }
            NetworkLogic.vipReceivReword(data, function () {
                this._receiveReword(3);

            }.bind(this), () => {
                console.log("===返回失败")
            })
        }
        else if (param === "me") {
            cc.log("==mePos:", this.mePos);
            this.scrollView.scrollToOffset(cc.v2(this.mePos, 0), 0.1);

        }
        else if (param === "xima") {
            let XimaLayer = null;
            let xima = cc.find("Canvas/XimaLayer");
            if (!xima) {
                let hallUI: HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.onBtnClick(null, "xima");
                xima = cc.find("Canvas/XimaLayer");
            }
            XimaLayer = xima.getComponent("XimaLayer");
            XimaLayer.toggleContainer.toggleItems[2].check();
            XimaLayer.onToggleSelected(null, "ximabili");
            this.node.destroy();
        }
    }
    onToggleSelected(event, param) {
        AudioManager.playSound("toggle");
        this.tempI = Number(param);
        if (isNaN(this.tempI)) return;
        this._setBottom(this.tempI);
    }
    _setBottom(i: number) {
        console.log("====this.userVipSettings:", this.userVipSettings)
        let item = this.userVipSettings[i];
        this.tempLevel = item.id;
        this.labjjMoney.string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) +  item.advanceGiftMoney;
        this.labWeekMoney.string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + item.weekGiftMoney;
        this.labMonMoney.string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + item.monthGiftMoney;
        this.labjjLingQu.string = item.receiveStatus === 0 ? i18n.t('msg_text.receive') : i18n.t('label_text.receive');
        this.labWeekLingQu.string = item.weekStatus === 0 ? i18n.t('msg_text.receive') : i18n.t('label_text.receive');
        this.labMonLingQu.string = item.monthStatus === 0 ? i18n.t('msg_text.receive') : i18n.t('label_text.receive');
        let bjj = (item.receiveStatus === 0 || item.receiveStatus === 2) ? false : true;
        let bweekstate = (item.weekStatus === 0 || item.weekStatus === 2) ? false : true;
        let bmonthstate = (item.monthStatus === 0 || item.monthStatus === 2) ? false : true;

        bjj = (item.advanceGiftMoney === 0 ? false : bjj);
        bweekstate = (item.weekGiftMoney === 0 ? false : bweekstate);
        bmonthstate = (item.monthGiftMoney === 0 ? false : bmonthstate);
        this.btnjj.interactable = bjj;
        this.btnWeek.interactable = bweekstate;
        this.btnMon.interactable = bmonthstate;
    }
    _receiveReword(receiveType) {
        NetworkLogic.lowerScore(0, function (data) {
            Player.setPy("money", data)
        }.bind(this), function (response) {
            if (!response) return
            UIManager.showToastUI(i18n.t('vip_text.get_error'), Global.ToastType.Warnning)
        }.bind(this));
        let item = this.userVipSettings[this.tempI];
        this.tempLevel = item.id;
        this.labjjMoney.string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + item.advanceGiftMoney;
        let money = 0;
        if (receiveType === 1) {
            item.receiveStatus = 0;
            money = item.advanceGiftMoney
        } else if (receiveType === 2) {
            item.weekStatus = 0;
            money = item.weekGiftMoney;
        } else if (receiveType === 3) {
            item.monthStatus = 0;
            money = item.monthGiftMoney;
        }
        cc.director.emit(Global.UserEvent.OpenBaoxiang, money);
        this._setBottom(this.tempI);
    }

}
